import Api from 'services/api';
import { ApiRequestForm } from 'pages/ConlicitacaoApiRequest/types';

export interface ApiRequestEvent {
  id: number;
  status_id: number;
  status?: { id: number; nome: string } | null;
  alterado_por?: number | null;
  motivo?: string | null;
  created_at?: string | null;
}

export interface ApiRequestStatusInfo {
  id: number;
  cliente_id: number;
  status_id: number;
  status?: { id: number; nome: string } | null;
  motivo?: string | null;
  dados?: ApiRequestForm | null;
  eventos?: ApiRequestEvent[];
}

// Exige status_id numérico: se a rota falhar e o proxy/SPA devolver HTML, qualquer
// resposta não vazia viraria "tem solicitação".
const isApiRequestStatus = (value: unknown): value is ApiRequestStatusInfo =>
  Boolean(value) &&
  typeof value === 'object' &&
  typeof (value as { status_id?: unknown }).status_id === 'number';

// cliente_id e solicitado_por vêm da sessão no boletim (Rails); o front manda só os dados.
export const sendApiRequest = async (
  dados: ApiRequestForm,
): Promise<ApiRequestStatusInfo | null> => {
  const { data } = await Api.post('/conlicitacao_api/solicitacoes', { dados });
  return isApiRequestStatus(data) ? data : null;
};

export const updateApiRequest = async (
  id: number,
  dados: ApiRequestForm,
): Promise<ApiRequestStatusInfo | null> => {
  const { data } = await Api.put(`/conlicitacao_api/solicitacoes/${id}`, { dados });
  return isApiRequestStatus(data) ? data : null;
};

export const getApiRequestStatus = async (): Promise<ApiRequestStatusInfo | null> => {
  const { data } = await Api.get('/conlicitacao_api/solicitacoes/status');
  return isApiRequestStatus(data) ? data : null;
};

export interface MyTokensInfo {
  api_token: string | null;
  ips: { ip: string; status: number }[];
}

export const getMyTokens = async (): Promise<MyTokensInfo> => {
  const { data } = await Api.get('/conlicitacao_api/meus_tokens');
  const apiToken = data && typeof data.api_token === 'string' ? data.api_token : null;
  const ips = data && Array.isArray(data.ips) ? data.ips : [];
  return { api_token: apiToken, ips };
};
